/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeaderboardMyRankResponse
 */
export interface LeaderboardMyRankResponse {
    /**
     * True when the user has joined (progression exists) — can be true with rank null (no counted events yet).
     * @type {boolean}
     * @memberof LeaderboardMyRankResponse
     */
    isParticipating: boolean;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardMyRankResponse
     */
    rank: number | null;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardMyRankResponse
     */
    value: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardMyRankResponse
     */
    eventCount: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardMyRankResponse
     */
    previousRank?: number;
    /**
     * Signed movement since the previous ranking computation (positive = climbed).
     * @type {number}
     * @memberof LeaderboardMyRankResponse
     */
    rankChange?: number;
    /**
     * 0-100; higher is better. Denominator is the current deduped field, same as the standings total.
     * @type {number}
     * @memberof LeaderboardMyRankResponse
     */
    percentile?: number;
}

/**
 * Check if a given object implements the LeaderboardMyRankResponse interface.
 */
export function instanceOfLeaderboardMyRankResponse(value: object): value is LeaderboardMyRankResponse {
    if (!('isParticipating' in value) || value['isParticipating'] === undefined) return false;
    if (!('rank' in value) || value['rank'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('eventCount' in value) || value['eventCount'] === undefined) return false;
    return true;
}

export function LeaderboardMyRankResponseFromJSON(json: any): LeaderboardMyRankResponse {
    return LeaderboardMyRankResponseFromJSONTyped(json, false);
}

export function LeaderboardMyRankResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardMyRankResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isParticipating': json['isParticipating'],
        'rank': json['rank'],
        'value': json['value'],
        'eventCount': json['eventCount'],
        'previousRank': json['previousRank'] == null ? undefined : json['previousRank'],
        'rankChange': json['rankChange'] == null ? undefined : json['rankChange'],
        'percentile': json['percentile'] == null ? undefined : json['percentile'],
    };
}

export function LeaderboardMyRankResponseToJSON(json: any): LeaderboardMyRankResponse {
    return LeaderboardMyRankResponseToJSONTyped(json, false);
}

export function LeaderboardMyRankResponseToJSONTyped(value?: LeaderboardMyRankResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isParticipating': value['isParticipating'],
        'rank': value['rank'],
        'value': value['value'],
        'eventCount': value['eventCount'],
        'previousRank': value['previousRank'],
        'rankChange': value['rankChange'],
        'percentile': value['percentile'],
    };
}

